import React, { FormEvent } from 'react';

interface IProps {
  children: React.ReactNode;
  onSubmit?: () => void;
}

const AdvancedForm = ({ children, onSubmit }: IProps) => {
  const formSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (onSubmit) {
      return onSubmit();
    }
  };

  return (
    <div className="advanced-form">
      <form onSubmit={formSubmit}>{children}</form>
    </div>
  );
};

export default AdvancedForm;
